import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { OVERALL_CATEGORY } from '../config'
import { TSType } from '../models'

import { getFieldName } from './getFieldName'
import { getIsCollapsedL3Category } from './getIsCollapsedL3Category'

/**
 * Obsolete, use getFinSobValue
 */
export const getPlanValue = (
  setting: IFormActualsTargetsSettings,
  items: IJBPPlanningItem[],
  partnerId: string,
  fyear: number,
  fq: number,

  actualsType: ActualsValueTypes,
  isUnits: boolean,
  currency: string,
  isCollapsed: boolean,
  sType: TSType,
  isSoB: boolean,
  isDirect: boolean,
  isShowOnlyCompletedPlans: boolean,
  isShowComposedSoB: boolean,
  isRecalcPlans: boolean,

  isComposedReportMode?: boolean,
  isQuarterlyBusinessReviewMode?: boolean,

  useFieldName?: string
): number => {
  let result = 0

  let fieldName = useFieldName
    ? useFieldName
    : getFieldName({ actualsType, isUnits, currency, sType, isSoB, isDirect })

  if (!useFieldName && isComposedReportMode) {
    if (isShowOnlyCompletedPlans) {
      fieldName = `${fieldName}Completed`
    }
    if (isShowComposedSoB && !isSoB) {
      fieldName = `${fieldName}Sob`
    }
  }

  const subCat = setting.SubCategory
  const isOverall = subCat === OVERALL_CATEGORY || !subCat
  const l3Cat = setting.L3Category
  const isL3Overall = l3Cat === OVERALL_CATEGORY
  const isL3 = !!l3Cat
  const isL3Collapsed = getIsCollapsedL3Category(items, fyear, subCat)

  const isOverallCollapsed = isOverall && isCollapsed
  const isL2Ordinary = !isOverall && !isL3
  const isL3Ordinary = isL3 && !isL3Overall
  const isL3OverallCollapsed = isL3 && isL3Overall && isL3Collapsed

  const isSkipReCalc = isOverallCollapsed || isL2Ordinary || isL3OverallCollapsed || isL3Ordinary

  // Reclculate Target and Actuals
  const isRecalcMode = isComposedReportMode && isRecalcPlans && !isSoB

  if (isRecalcMode && !isSkipReCalc) {
    if (isL3 && isL3Overall && !isL3Collapsed) {
      // Recalc L3 Overall
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || !!isComposedReportMode) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          // Recalc L3 Overall - sum L3 Details
          el.L3Category &&
          el.L3Category !== OVERALL_CATEGORY &&
          el.FYear === fyear &&
          el.FQuarter === fq
      )
      if (sourceData.length >= 1) {
        sourceData.forEach((el) => {
          result += el[fieldName] || 0
        })
      } else {
        // error in data
      }
    } else {
      // Recalc Overall
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || !!isComposedReportMode) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          // Summ:
          // 1. Not Overall
          el.SubCategory !== OVERALL_CATEGORY &&
          // 2. L2 not Overall
          (!el.L3Category ||
            // 3. L3 Overall Collapsed
            (el.L3Category &&
              el.L3Category === OVERALL_CATEGORY &&
              getIsCollapsedL3Category(items, fyear, el.SubCategory)) ||
            // 4. Recalc L3 Overall Not Collapsed - sum L3 Details
            (el.L3Category &&
              el.L3Category !== OVERALL_CATEGORY &&
              !getIsCollapsedL3Category(items, fyear, el.SubCategory))) &&
          //
          el.FYear === fyear &&
          el.FQuarter === fq
      )
      if (sourceData.length >= 1) {
        sourceData.forEach((el) => {
          result += el[fieldName] || 0
        })
      } else {
        // error in data
      }
    }
  } else {
    // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
    const sourceData = items.filter(
      (el) =>
        (el.PartnerId === partnerId || !!isComposedReportMode || !!isQuarterlyBusinessReviewMode) &&
        el.ProgramTypes === setting.ProgramType &&
        el.Category === setting.Category &&
        el.SubCategory === setting.SubCategory &&
        el.L3Category === setting.L3Category &&
        el.FYear === fyear &&
        el.FQuarter === fq
    )
    if (sourceData.length >= 1) {
      const value = sourceData[0][fieldName]
      result = value === undefined ? null : value
    } else {
      // error in data
    }
  }

  return result
}
